export * from '@fhs/routing/src/routes/(drawer)/support/categories/[categoryId]';
export { default } from '@fhs/routing/src/routes/(drawer)/support/categories/[categoryId]';
